import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AlertService} from '../../util/alert/alert.service';
import {UserDataService} from '../../admin/user/user-data.service';
import {LocalStorage} from '../../util/localstorage.service';
import {User} from '../../models/user.model';
import {DatePipe} from '@angular/common';
import {Location} from '@angular/common';
import {Constants} from '../../util/constants';
@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
  public loggedUser: User
  public paddingtop: number = 160;
  public user:User;
  public email
  public id
  public iSForm: FormGroup;

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
              private userService: UserDataService, private _location: Location) { }

  ngOnInit() {
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if ((this.loggedUser != null)) {
      this.email = this.loggedUser.Email;
      this.id = this.loggedUser.UserID
    } else {
      this.router.navigateByUrl('');
    }
    this.iSForm = this.formBuilder.group({
      email: new FormControl(null)
    } );
    this.loadData()
  }

  loadData()
  {
    this.alertService.clear()
    this.userService.getUserByID(this.loggedUser, this.id).subscribe(data => this.getData(data))
  }

  cancelBtnClickEvent(){
    this._location.back();
  }

  deleteBtnClickEvent(){
    this.user.bDeleteRequested = Constants.bDeleted.True;
    this.user.DeleteRequestOn = new Date()
    if (confirm("Are you sure you want to delete your account?")) {
      this.userService.saveUser(this.user, this.loggedUser).subscribe(date =>
        {
          this.alertService.clear()
          this.loadData()
          this.alertService.success('Successfully submitted the delete request.')
          // localStorage.clear();
          // this.router.navigateByUrl('')
        },
        error => {
          this.alertService.clear()
          this.alertService.error('Error occured while saving data')

        });
    }

  }

  public getData(data: any) {
    this.user  = data
    if (this.user != null && this.user != undefined){
      localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(this.user));
    }


    this.email = data.Email
  }
}
